<div class="mb-4">
  @if (!isExternalUser) {
    <p-panel
      [header]="provider?.providerAccountDTO?.providerName"
      [collapsed]="false"
      toggler="header"
      [class.widget-first-level]="isWidgetFirstLevel"
      data-test-id="general-information-header"
    >
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data mt-4">
        <div class="col-span-12 md:col-span-4">
          <div class="field">
            <p class="font-semibold">General</p>
          </div>
          <div class="field">
            <label>Parent Company Name:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.parentCompany }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>NPI:</label>
            <div class="p-field-value">
              <div class="readonly-field" data-test-id="tax-id-value">
                {{ providerCombineData?.npi }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Portal Provider ID:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.accountId }}
              </div>
            </div>
          </div>
          <div class="field items-center">
            <label data-test-id="network" [class]="{ 'field-required': authRequest }">Network:</label>
            <div class="p-field-value">
              @if (!authRequest) {
                <div class="flex">
                  @if (!isNetworkEditable && !isParticipatingNetworksNeeded) {
                    <ng-container class="flex">
                      <div class="readonly-field flex items-center">
                        <span data-test-id="network-label">{{ providerCombineData?.participatingNetworks }}</span>
                        <ng-container *accessController="[
                        'AppealGrievance',
                        'OperationsAdmin',
                        'Operations',
                        'Internal',
                        'LetterMapsManager'
                      ]">
                          @if (!reviewMode) {
                            <button
                              pButton
                              type="button"
                              label="Update"
                              class="ml-4 network-field-controls"
                              [disabled]="isNetworkDisabled"
                              (click)="isNetworkEditable = true"
                              data-test-id="network-update"
                            ></button>
                          }
                        </ng-container>
                      </div>
                    </ng-container>
                  }
                  @if (isNetworkEditable || isParticipatingNetworksNeeded) {
                    <p-select
                      placeholder="Select"
                      appendTo="body"
                      [options]="networkOption"
                      class="left-spacing"
                      (onChange)="selectNetwork($event)"
                      required
                      data-test-id="select-network"
                    ></p-select>
                    @if (!isParticipatingNetworksNeeded) {
                      <button
                        pButton
                        type="button"
                        label="Cancel"
                        class="p-button-secondary ml-4 network-field-controls"
                        (click)="isNetworkEditable = false"
                        data-test-id="cancel-network"
                      ></button>
                    }
                    <button
                      pButton
                      type="button"
                      class="network-field-controls ml-4"
                      label="Save"
                      (click)="updateCurrentAuthorization()"
                      data-test-id="save-network"
                    ></button>
                  }
                </div>
              }
              @if (authRequest) {
                <p-select
                  placeholder="Select"
                  appendTo="body"
                  [options]="networkOption"
                  [(ngModel)]="networkValue"
                  class="left-spacing network-field-controls"
                  (onChange)="selectNetwork($event)"
                  data-test-id="select-network"
                ></p-select>
              }
            </div>
          </div>
          <div class="field">
            <label data-test-id="out-of-network">Out of Network:</label>
            <div class="p-field-checkbox-container">
              <p-checkbox
                binary="true"
                [disabled]="true"
                [ngModel]="providerCombineData?.participationStatus"
                data-test-id="out-of-network-checkbox"
              ></p-checkbox>
            </div>
          </div>
          <div class="field">
            <label data-test-id="tax-id">Tax ID:</label>
            <div class="p-field-value">
              <div class="readonly-field" data-test-id="tax-id-value">
                {{ providerCombineData?.taxId }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="cmsnumber">CMS Number:</label>
            <div class="p-field-value">
              <div class="readonly-field" data-test-id="cmsnumber-value">
                {{ providerCombineData?.cmsnumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="medicaid-number">Medicaid Number:</label>
            <div class="p-field-value">
              <div class="readonly-field" data-test-id="medicaid-number-value">
                {{ providerCombineData?.medicaidNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="reimbursement-structure">Reimbursement Structure:</label>
            <div class="p-field-value">
              @if (tenantName === 'Humana') {
                <div>
                  <div class="readonly-field" data-test-id="reimbursement-structure-value">
                    {{ providerCombineData?.reimbursementType === 'Episodic' ? 'Medicare' : providerCombineData?.reimbursementType === 'MED' ? 'Medicare' : providerCombineData?.reimbursementType }}
                  </div>
                </div>
              } @else {
                <div class="readonly-field" data-test-id="reimbursement-structure-value">
                  {{ providerCombineData?.reimbursementType === 'MED' ? 'Medicare' : providerCombineData?.reimbursementType }}
                </div>
              }
            </div>
          </div>
          <div class="field">
            <label>Review Period Exception:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData ? (providerCombineData.reviewPeriodException ? 'Yes' : 'No') : '' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-4">
          <div class="field">
            <p class="font-semibold">Location Information</p>
          </div>
          <div class="field">
            <label>Street:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.physicalStreet }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>City:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.physicalCity }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>State:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.physicalState }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Zip Code:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.physicalZip }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.locationPhone | phoneNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.locationFax | phoneNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax Confirmed?:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData ? (providerCombineData.locationFaxConfirmed ? 'Yes' : 'No') : '' }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax Confirmed Date:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.faxConfirmedDate | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12 md:col-span-4">
          <div class="field">
            <label class="font-semibold">Authorization Information</label>
          </div>
          <div class="field">
            <label>Phone:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.authorizationPhone | phoneNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.authorizationFax | phoneNumber }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax Confirmed:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData ? (providerCombineData.authorizationFaxConfirmed ? 'Yes' : 'No') : '' }}
              </div>
            </div>
          </div>
          <div class="field">
            <label>Fax Confirmed Date:</label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ providerCombineData?.authorizationFaxConfirmedDate | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (serviceLocationDTO) {
        <p-panel class="mb-4 mt-4" header="Service Location" [toggleable]="true" [collapsed]="false" toggler="header"
                 data-test-id="service-location">
          <ng-template #headericons let-collapsed>
            <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
          </ng-template>
          <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data">
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <label data-test-id="address-type">Service Address Type:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="address-type-value">
                    {{ serviceLocationDTO.serviceAddressType }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="address-location">Service Address Location:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="address-location-value">
                    {{ serviceLocationDTO.serviceAddressLocationType }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="address-1">Address 1:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="address-1-value">
                    {{ serviceLocationDTO.address1 }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="address-2">Address 2:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="address-2-value">
                    {{ serviceLocationDTO.address2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <label data-test-id="city">City:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="city-value">
                    {{ serviceLocationDTO.city }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="state">State:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="state-value">
                    {{ serviceLocationDTO.state }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="zip">ZIP Code:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="zip-value">
                    {{ serviceLocationDTO.zipCode | zipCode }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="county">County:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="county-value">
                    {{ serviceLocationDTO.county }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      }
      @if (showHistoryTable) {
        <app-provider-history-table
          [authNumber]="authNumber"
          [providerAccountId]="providerAccountId"
          [tenantId]="tenantId"
        ></app-provider-history-table>
      }
    </p-panel>
  }
  @if (isExternalUser) {
    <div>
      <p-panel
        class="mb-4"
        header="General Information"
        [toggleable]="true"
        [collapsed]="false"
        toggler="header"
        [class.widget-first-level]="isWidgetFirstLevel"
        data-test-id="general-information-header"
      >
        <ng-template #headericons let-collapsed>
          <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
        </ng-template>
        <p-table
          [columns]="generalInfoColumns"
          [value]="[providerCombineData]"
          [rows]="1"
          [scrollable]="false"
        >
          <ng-template pTemplate="colgroup" let-columns>
            <colgroup>
              @for (col of columns; track col) {
                <col [style.width]="col.width">
              }
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header" let-columns let-i="index">
            <tr>
              @for (col of columns; track col) {
                <th>
                  <span [innerText]='col.header' [attr.data-test-id]=" 'general-item' + i + '-header'"></span>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-provider let-columns="columns" let-i="index">
            <tr>
              <td [attr.data-test-id]=" 'general-item' + i + '-parent-company'">
                {{ provider?.parentCompany }}
              </td>
              <td [attr.data-test-id]=" 'general-item' + i + '-npi'">
                {{ provider?.npi }}
              </td>
              <td>
                @if (authRequest) {
                  <div class="field-required">
                    <p-select
                      placeholder="Select"
                      appendTo="body"
                      [options]="networkOption"
                      [(ngModel)]="networkValue"
                      class="left-spacing"
                      (onChange)="selectNetwork($event)"
                      [attr.data-test-id]=" 'general-item' + i + '-network-dropdown'"
                    ></p-select>
                  </div>
                }
                @if (!authRequest) {
                  <span
                    [attr.data-test-id]=" 'general-item' + i + '-networks'">{{ provider?.participatingNetworks }}</span>
                }
              </td>
              <td [class]="{'attention-mark': provider?.participationStatus}">
                <div class="p-field-checkbox-container checkbox-align">
                  <p-checkbox
                    binary="true"
                    [disabled]="true"
                    [ngModel]="providerCombineData?.participationStatus"
                    [attr.data-test-id]=" 'general-item' + i + '-participation-status'"
                  ></p-checkbox>
                </div>
              </td>
              <td [attr.data-test-id]=" 'general-item' + i + '-tax-id'">
                {{ provider?.taxId }}
              </td>
              <td [attr.data-test-id]=" 'general-item' + i + '-cms-number'">
                {{ provider?.cmsnumber }}
              </td>
              <td [attr.data-test-id]=" 'general-item' + i + '-medicaid-number'">
                {{ provider?.medicaidNumber }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <p-panel class="mb-4 mt-4" header="Contact Information" [toggleable]="true" [collapsed]="false" toggler="header"
                 data-test-id="contact-info-tab">
          <ng-template #headericons let-collapsed>
            <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
          </ng-template>
          <p-table
            [columns]="contactInfoColumns"
            [value]="[providerCombineData]"
            [rows]="1"
            [scrollable]="false"
          >
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                @for (col of columns; track col) {
                  <col [style.width]="col.width">
                }
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns let-i="index">
              <tr>
                @for (col of columns; track col) {
                  <th>
                    <span [innerText]='col.header' [attr.data-test-id]=" 'contact-info-item' + i + '-label'"></span>
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-provider let-columns="columns" let-i="index">
              <tr>
                <td [attr.data-test-id]=" 'contact-info-item' + i + '-physical-street'">
                  {{ provider?.physicalStreet }}
                </td>
                <td [attr.data-test-id]=" 'contact-info-item' + i + '-physical-city'">
                  {{ provider?.physicalCity }}
                </td>
                <td [attr.data-test-id]=" 'contact-info-item' + i + '-physical-state'">
                  {{ provider?.physicalState }}
                </td>
                <td [attr.data-test-id]=" 'contact-info-item' + i + '-physical-zip'">
                  {{ provider?.physicalZip }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data mt-4">
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <p class="font-semibold" data-test-id="location-info">Location Information</p>
              </div>
              <div class="field">
                <label data-test-id="location-info-phone">Location Phone:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="location-info-phone-value">
                    {{ providerCombineData?.locationPhone | phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="location-info-fax">Location Fax:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="location-info-fax-value">
                    {{ providerCombineData?.locationFax | phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="fax-confirmed">Location Fax Confirmed?:</label>
                <div class="p-field-value">
                  <div class="p-field-checkbox-container">
                    <p-checkbox
                      binary="true"
                      [disabled]="true"
                      [ngModel]="providerCombineData?.locationFaxConfirmed"
                      data-test-id="fax-confirmed-checkbox"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="fax-confirmed-date">Location Fax Confirmed Date:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="fax-confirmed-date-value">
                    {{ providerCombineData?.faxConfirmedDate | date: 'MM/dd/yyyy' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-12 md:col-span-6">
              <div class="field">
                <p class="font-semibold" data-test-id="authorization-info">Authorization Information</p>
              </div>
              <div class="field">
                <label data-test-id="authorization-phone">Authorization Phone:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="authorization-phone-value">
                    {{ providerCombineData?.authorizationPhone | phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="authorization-fax">Authorization Fax:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="authorization-fax-value">
                    {{ providerCombineData?.authorizationFax | phoneNumber }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="authorization-fax-confirmed">Authorization Fax Confirmed?:</label>
                <div class="p-field-value">
                  <div class="p-field-checkbox-container">
                    <p-checkbox
                      binary="true"
                      [disabled]="true"
                      [ngModel]="providerCombineData?.authorizationFaxConfirmed"
                      data-test-id="authorization-fax-condifrmed-value"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="authorization-fax-confirmed-date">Authorization Fax Confirmed Date:</label>
                <div class="p-field-value">
                  <div class="readonly-field" data-test-id="authorization-fax-confirmed-date-value">
                    {{ providerCombineData?.authorizationFaxConfirmedDate | date: 'MM/dd/yyyy' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
        @if (serviceLocationDTO) {
          <p-panel class="mb-4 mt-4" header="Service Location" [toggleable]="true" [collapsed]="false" toggler="header"
                   data-test-id="service-location">
            <ng-template #headericons let-collapsed>
              <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
            </ng-template>
            <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data">
              <div class="col-span-12 md:col-span-6">
                <div class="field">
                  <label data-test-id="address-type">Service Address Type:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="address-type-value">
                      {{ serviceLocationDTO.serviceAddressType }}
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label data-test-id="address-location">Service Address Location:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="address-location-value">
                      {{ serviceLocationDTO.serviceAddressLocationType }}
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label data-test-id="address-1">Address 1:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="address-1-value">
                      {{ serviceLocationDTO.address1 }}
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label data-test-id="address-2">Address 2:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="address-2-value">
                      {{ serviceLocationDTO.address2 }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-12 md:col-span-6">
                <div class="field">
                  <label data-test-id="city">City:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="city-value">
                      {{ serviceLocationDTO.city }}
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label data-test-id="state">State:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="state-value">
                      {{ serviceLocationDTO.state }}
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label data-test-id="zip">ZIP Code:</label>
                  <div class="p-field-value">
                    <div class="readonly-field" data-test-id="zip-value">
                      {{ serviceLocationDTO.zipCode | zipCode }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </p-panel>
        }
        @if (showHistoryTable && !isExternalUser) {
          <app-provider-history-table
            [authNumber]="authNumber"
            [providerAccountId]="providerAccountId"
            [tenantId]="tenantId"
          ></app-provider-history-table>
        }
      </p-panel>
    </div>
  }
</div>
